import Vue from 'vue'
import axios from 'axios'
import 'lib-flexible'
import '../static/style/common.scss'
import common from '../static/js/common'
//注册到vue原型上
Vue.prototype.common = common
Vue.prototype.axios = axios






//////////////////
// WEBPACK FOOTER
// ./config/configuration.js
// module id = null
// module chunks = 